<template>
  <div class="flex flex-1 items-center justify-center p-8">
    <p class="text-sm text-n-slate-11">Engage Goals</p>
  </div>
</template>
